import axios from 'axios'
import store from './store'
import throttle from 'lodash/throttle'

const url = process.env.NODE_ENV === 'production' ? 'https://unelma.bojaco.com/wp-json/unelmakone/v1' : 'https://unelmakone.test/wp-json/unelmakone/v1'
const instance = axios.create({
  baseURL: url,
  timeout: 5000
})

const getCall = async (url, id = 'defaultCall') => {
  return new Promise((resolve, reject) => {
    store.commit('working', { id, start: true })
    instance.get(url)
      .then(response => {
        store.commit('working', { id, start: false })
        resolve(response)
      })
      .catch(reason => {
        store.commit('working', { id, start: false })
        reject(reason)
      })
  })
}

export const postCall = async (url, data, id = 'defaultCall') => {
  return new Promise((resolve, reject) => {
    store.commit('working', { id, start: true })
    instance.post(url, data)
      .then(response => {
        store.commit('working', { id, start: false })
        resolve(response)
      })
      .catch(reason => {
        store.commit('working', { id, start: false })
        reject(reason)
      })
  })
}

export const fetchPages = throttle(() => {
  getCall('/pages', 'pages')
    .then(response => {
      console.debug(response.data)
      store.commit('pages', { pages: response.data })
    })
}, 10000)

export const fetchQuestions = throttle(() => {
  getCall('/questions', 'questions')
    .then(response => {
      console.debug(response.data.residency)
      store.commit('questions', { questions: response.data })
    })
}, 10000)

export const fetchLocations = throttle(() => {
  getCall('/locations', 'locations')
    .then(response => {
      console.debug(response.data)
      store.commit('locations', { locations: response.data })
    })
}, 10000)

export const fetchRealtors = throttle(() => {
  getCall('/realtors', 'realtors')
    .then(response => {
      console.debug(response.data)
      store.commit('realtors', { realtors: response.data })
    })
}, 10000)
